module.exports = __webpack_public_path__ + "img/崔桂秋.97d1572f.jpg";